import { TagsIcon } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';
import WsTagsFilter from './WsTagsFilter';

const TagsFilter = ({ name, defaultValue, showAccordionIcon }: WsFilterProps) => (
  <WsAccordion title="Tags" {...(showAccordionIcon && { startIcon: <TagsIcon /> })}>
    <WsTagsFilter name={name} defaultValue={defaultValue} label="" />
  </WsAccordion>
);

export default TagsFilter;
